import { render, staticRenderFns } from "./MessageNavi.vue?vue&type=template&id=2f3f2cfb&scoped=true"
import script from "./MessageNavi.vue?vue&type=script&lang=js"
export * from "./MessageNavi.vue?vue&type=script&lang=js"
import style0 from "./MessageNavi.vue?vue&type=style&index=0&id=2f3f2cfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3f2cfb",
  null
  
)

export default component.exports